import { Dispatch, createContext, useReducer } from "react";
import { uiReducer, UIReducerAction } from "../reducers/uiReducer";

export interface UIContent {
  showDeviceDetail?: boolean;
  showDeviceFunction?: boolean;
}

interface UIContextInterface {
  uiState: UIContent;
  uiDispatch: Dispatch<UIReducerAction>;
}

const DefaultState = {
  showDeviceDetail: false,
  showDeviceFunction: true,
};

export const UIContext = createContext<UIContextInterface>({uiState: DefaultState, uiDispatch: () => {}});

const UIContextProvider = ({ children }: { children: JSX.Element }) => {
  const [uiState, uiDispatch] = useReducer(uiReducer, DefaultState);

  return (
    <UIContext.Provider value={ { uiState, uiDispatch } }>
      { children }
    </UIContext.Provider>
  );
};

export default UIContextProvider;
